/* unplugin-vue-components disabled */import { ElDialog as __unplugin_components_5 } from 'element-plus/es';import 'element-plus/es/components/dialog/style/css';
import { ElButton as __unplugin_components_4 } from 'element-plus/es';import 'element-plus/es/components/button/style/css';
import { ElForm as __unplugin_components_3 } from 'element-plus/es';import 'element-plus/es/components/form/style/css';
import { ElInput as __unplugin_components_2 } from 'element-plus/es';import 'element-plus/es/components/input/style/css';
import { ElFormItem as __unplugin_components_1 } from 'element-plus/es';import 'element-plus/es/components/form-item/style/css';
import { ElDivider as __unplugin_components_0 } from 'element-plus/es';import 'element-plus/es/components/divider/style/css';
import "core-js/modules/es.array.push.js";
import { defineComponent as _defineComponent } from 'vue';
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createBlock as _createBlock } from "vue";
const _hoisted_1 = /*#__PURE__*/_createTextVNode("帮助中心");
const _hoisted_2 = /*#__PURE__*/_createTextVNode("切换账号");
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", {
  style: {
    "font-size": "10px"
  }
}, "入口位于登陆成功浮动条，开启后用户可在登陆过程中切换账号", -1);
const _hoisted_4 = /*#__PURE__*/_createTextVNode("个人中心");
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", {
  style: {
    "font-size": "10px"
  }
}, "入口位于登陆成功浮动条，开启后用户可在登陆过程中进入个人中心", -1);
const _hoisted_6 = /*#__PURE__*/_createTextVNode("账号注销");
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", {
  style: {
    "font-size": "10px"
  }
}, "入口位于个人中心左下角，开启后非游客用户可以进行账号注销", -1);
const _hoisted_8 = {
  class: "dialog-footer"
};
const _hoisted_9 = /*#__PURE__*/_createTextVNode("取消");
const _hoisted_10 = /*#__PURE__*/_createTextVNode("确定");
import USwitch from '@ultra/share/components/USwitch/index.vue';
import { EMAILREG, URLREG } from '@/utils/reg';
import { apiUsdkPageConfEdit } from '@/api/usdk';
export default /*#__PURE__*/_defineComponent({
  emits: ['success'],
  setup(__props, {
    expose,
    emit: emits
  }) {
    const dialogVisible = ref(false);
    const confirmLoading = ref(false);
    const form = ref({
      help: {
        memo: null,
        id: '',
        var: 'hg.switch.showHelpDialog',
        val: '0',
        caption: '',
        surfix: ''
      },
      loginSwitch: {
        memo: null,
        id: '',
        var: 'hg.float.loginSwitch',
        val: '0',
        caption: '',
        surfix: ''
      },
      showLoginBind: {
        memo: null,
        id: '',
        var: 'hg.switch.showLoginBind',
        val: '0',
        caption: '',
        surfix: ''
      },
      logout: {
        memo: null,
        id: '',
        var: 'hg.cs.logout',
        switch: '0',
        val: '',
        caption: '',
        surfix: ''
      },
      email: {
        memo: null,
        id: '',
        var: 'hg.cs.email',
        val: '',
        caption: '',
        surfix: ''
      },
      fans: {
        memo: null,
        id: '',
        var: 'hg.cs.fbfans',
        val: '',
        caption: '',
        surfix: ''
      },
      tel: {
        memo: null,
        id: '',
        var: 'hg.cs.tel',
        val: '',
        caption: '',
        surfix: ''
      }
    });
    const formRef = ref();
    const handleClose = () => {
      dialogVisible.value = false;
    };
    const handleChangeLoginout = val => {
      if (val === 0) {
        form.value.logout.val = '';
      }
    };
    const show = payload => {
      dialogVisible.value = true;
      form.value.gid = payload.data.gid;
      form.value.cid = payload.data.cid;
      console.log('payload.data', payload.data);
      for (let key in form.value) {
        if (key === 'help') {
          form.value[key] = payload.data.conf[3];
        }
        if (key === 'loginSwitch') {
          form.value[key] = payload.data.conf[1];
        }
        if (key === 'showLoginBind') {
          form.value[key] = payload.data.conf[0];
        }
        if (key === 'logout') {
          form.value[key] = payload.data.conf[2];
          if (!payload.data.conf[2].val) {
            form.value[key].switch = 0;
          } else {
            form.value[key].switch = 1;
          }
        }
        if (key === 'email') {
          form.value[key] = payload.data.conf[4];
        }
        if (key === 'fans') {
          form.value[key] = payload.data.conf[5];
        }
        if (key === 'tel') {
          form.value[key] = payload.data.conf[6];
        }
      }
    };
    const handleOk = () => {
      let copyForm = JSON.parse(JSON.stringify(form.value));
      console.log('copyForm', copyForm);
      let data = [];
      for (let key in copyForm) {
        if (typeof copyForm[key] === 'object') {
          if (key === 'logout') {
            if (copyForm[key].switch > 0 && !copyForm[key].val) {
              ElMessage.error('请输入账号注销地址');
              return;
            }
          }
          data.push(copyForm[key]);
        }
      }
      data = JSON.stringify(data);
      console.log('data', data);
      confirmLoading.value = true;
      apiUsdkPageConfEdit({
        data
      }).then(res => {
        if (res.code === 0) {
          emits('success');
          handleClose();
        }
      }).finally(() => {
        confirmLoading.value = false;
      });
    };
    expose({
      show
    });
    return (_ctx, _cache) => {
      const _component_el_divider = __unplugin_components_0;
      const _component_el_form_item = __unplugin_components_1;
      const _component_el_input = __unplugin_components_2;
      const _component_el_form = __unplugin_components_3;
      const _component_el_button = __unplugin_components_4;
      const _component_el_dialog = __unplugin_components_5;
      return _openBlock(), _createBlock(_component_el_dialog, {
        modelValue: dialogVisible.value,
        "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => dialogVisible.value = $event),
        title: "配置",
        width: "50%",
        "before-close": () => handleClose()
      }, {
        footer: _withCtx(() => [_createElementVNode("span", _hoisted_8, [_createVNode(_component_el_button, {
          onClick: _cache[8] || (_cache[8] = $event => handleClose())
        }, {
          default: _withCtx(() => [_hoisted_9]),
          _: 1
        }), _createVNode(_component_el_button, {
          loading: confirmLoading.value,
          type: "primary",
          onClick: _cache[9] || (_cache[9] = $event => handleOk())
        }, {
          default: _withCtx(() => [_hoisted_10]),
          _: 1
        }, 8, ["loading"])])]),
        default: _withCtx(() => [_createVNode(_component_el_form, {
          model: form.value,
          ref_key: "formRef",
          ref: formRef,
          "label-width": "150px"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_divider, {
            "content-position": "left"
          }, {
            default: _withCtx(() => [_hoisted_1]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "“帮助”入口"
          }, {
            default: _withCtx(() => [_createVNode(USwitch, {
              valArr: ['0', '1'],
              modelValue: form.value.help.val,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => form.value.help.val = $event)
            }, null, 8, ["modelValue"])]),
            _: 1
          }), form.value.help.val > 0 ? (_openBlock(), _createElementBlock(_Fragment, {
            key: 0
          }, [_createVNode(_component_el_form_item, {
            label: "客服邮箱地址",
            prop: "email.val",
            rules: {
              pattern: _unref(EMAILREG),
              message: '请输入正确的邮箱地址',
              trigger: 'change'
            }
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: form.value.email.val,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => form.value.email.val = $event),
              placeholder: "请输入邮箱地址"
            }, null, 8, ["modelValue"])]),
            _: 1
          }, 8, ["rules"]), _createVNode(_component_el_form_item, {
            label: "Facebook粉丝页地址",
            prop: "fans.val",
            rules: {
              pattern: _unref(URLREG),
              message: '请输入正确的地址',
              trigger: 'change'
            }
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: form.value.fans.val,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => form.value.fans.val = $event),
              placeholder: "请输入粉丝页地址"
            }, null, 8, ["modelValue"])]),
            _: 1
          }, 8, ["rules"]), _createVNode(_component_el_form_item, {
            label: "客服电话"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: form.value.tel.val,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => form.value.tel.val = $event),
              placeholder: "请输入客服电话"
            }, null, 8, ["modelValue"])]),
            _: 1
          })], 64)) : _createCommentVNode("", true), _createVNode(_component_el_divider, {
            "content-position": "left"
          }, {
            default: _withCtx(() => [_hoisted_2]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "切换账号入口："
          }, {
            default: _withCtx(() => [_createElementVNode("div", null, [_createVNode(USwitch, {
              valArr: ['0', '1'],
              modelValue: form.value.loginSwitch.val,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => form.value.loginSwitch.val = $event)
            }, null, 8, ["modelValue"]), _hoisted_3])]),
            _: 1
          }), _createVNode(_component_el_divider, {
            "content-position": "left"
          }, {
            default: _withCtx(() => [_hoisted_4]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "个人中心入口："
          }, {
            default: _withCtx(() => [_createElementVNode("div", null, [_createVNode(USwitch, {
              valArr: ['0', '1'],
              modelValue: form.value.showLoginBind.val,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => form.value.showLoginBind.val = $event)
            }, null, 8, ["modelValue"]), _hoisted_5])]),
            _: 1
          }), _createVNode(_component_el_divider, {
            "content-position": "left"
          }, {
            default: _withCtx(() => [_hoisted_6]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "账号注销入口："
          }, {
            default: _withCtx(() => [_createElementVNode("div", null, [_createVNode(USwitch, {
              valArr: [0, 1],
              modelValue: form.value.logout.switch,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => form.value.logout.switch = $event),
              onChange: handleChangeLoginout
            }, null, 8, ["modelValue"]), _hoisted_7])]),
            _: 1
          }), form.value.logout.switch > 0 ? (_openBlock(), _createBlock(_component_el_form_item, {
            key: 1,
            label: "账号注销地址：",
            prop: "logout.val"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: form.value.logout.val,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => form.value.logout.val = $event),
              placeholder: "请输入url",
              rules: {
                pattern: _unref(URLREG),
                message: '请输入正确的地址',
                trigger: 'change'
              }
            }, null, 8, ["modelValue", "rules"])]),
            _: 1
          })) : _createCommentVNode("", true)]),
          _: 1
        }, 8, ["model"])]),
        _: 1
      }, 8, ["modelValue", "before-close"]);
    };
  }
});